/* eslint-disable array-callback-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { Table } from 'react-bootstrap';

function HearroCommonTable({
	tableHeader,
	tableBody,
	isCheck = false,
	checkedItems = [],
	setCheckedItems = null,
	isHover = false,
	isClick = false,
	clickEvent = null,
	isNumCol = true,
	pageCnt = 1
}) {
	const [totalCheck, setTotalCheck] = useState(false);

	const [selectItems, setSelectedItems] = useState({});

	function SelectAllItems(e) {
		const newSelectedItems = {};
		if (e.target.checked === true) {
			tableBody.map((item, idx) => {
				newSelectedItems[idx] = item;
			});
		}
		setSelectedItems(newSelectedItems);
		setTotalCheck(!totalCheck);
	}

	function SelectEachItem(e, item, idx) {
		const newSelectedItems = { ...selectItems };
		if (e.target.checked === false) {
			setTotalCheck(false);
			delete newSelectedItems[idx];
		} else {
			newSelectedItems[idx] = item;
		}
		setSelectedItems(newSelectedItems);
	}

	useEffect(() => {
		if(isCheck){
			if (checkedItems.length === 0 && Object.keys(selectItems).length !== 0) {
				setSelectedItems({});
			}
		}		
	}, [checkedItems]);

	useEffect(() => {
		if(isCheck){
			if (tableBody.length > 0 && Object.keys(selectItems).length === tableBody.length) {
				setTotalCheck(true);
			}
			setCheckedItems(Object.values(selectItems));
		}		
	}, [selectItems]);

	useEffect(()=>{
		if(isCheck){
			setTotalCheck(false);
		}		
	},[pageCnt])

	useEffect(()=>{
		const textDOMList = document.querySelectorAll('.hide_long_text');
		
		textDOMList.forEach(e=>{
			if(e.scrollWidth>e.clientWidth){
				e.classList.add('overflow');
			}else{
				e.classList.remove('overflow');
			}
		})
	},[tableBody])

	return (
		<Table hover={isHover}>
			<thead>
				<tr>
					{isCheck === true ? (
						<th align="center">
							<input
								type="checkbox"
								checked={totalCheck}
								onChange={e => {
									SelectAllItems(e);
								}}
							/>
						</th>
					) : null}
					{isNumCol && <th>번호</th>}
					{tableHeader.map((item, idx) => {
						return <th key={idx}>{item.value}</th>;
					})}
				</tr>
			</thead>
			<tbody>
				{tableBody.map((item, idx) => {
					return (
						<tr key={idx}>
							{isCheck === true ? (
								<td>
									<input
										type="checkbox"
										checked={idx in selectItems}
										onChange={e => SelectEachItem(e, item, idx)}
									/>
								</td>
							) : null}
							{isNumCol && <td
								style={{ cursor: isClick === true ? 'pointer' : 'default' }}
								onClick={() => (isClick ? clickEvent(item) : null)}
							>
								{(pageCnt - 1) * 10 + idx + 1}
							</td>}
							{tableHeader.map((headerItem, headerIdx) => {
								return (
									<td
										key={headerIdx}
										className={`${headerItem.value==="내용" ? 'hide_long_text' : ""}`}
										style={{ cursor: isClick === true ? 'pointer' : 'default' }}
										onClick={() => (isClick ? clickEvent(item) : null)}
									>
										{headerItem.key in item ? item[headerItem.key] : '-'}
									</td>
								);
							})}
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
}

export default HearroCommonTable;
